import React, { PureComponent } from 'react'
import { Dialog } from '@material-ui/core'

import {
  OverLimit,
  PaidStatus,
  ConfirmModal,
  PrintTickets,
  PrintBookingsSheet,
  SourceBookings,
  SelectRange,
  PrintBookingsRangeSheet,
  UserHistory,
  PassengerInfoModal,
  WaitingListModal,
  BlacklistBookingsModal
} from './components'

export class EnhancedModalBase extends PureComponent {
  onClose = () => this.props.hideModal()

  paidStatusSubmit = value => () => this.props.addSavedBooking({ paidStatus: value })

  overLimitSubmit = () => this.props.addSavedBooking()

  deleteBooking = () => {
    this.props.confirmAction()
    this.onClose()
  }

  cancelDeleting = () => {
    this.props.cancelAction()
    this.onClose()
  }

  types = {
    overLimit: (<OverLimit onClose={this.onClose} onSubmit={this.overLimitSubmit} />),
    paidStatus: (<PaidStatus onClose={this.onClose} onSubmit={this.paidStatusSubmit} />),
    deleteBooking: (<ConfirmModal
      title='Видалити бронювання?'
      onClose={this.cancelDeleting}
      onSubmit={this.deleteBooking}
    />),
    addBlacklistBooking: (<ConfirmModal
      title='Додати бронювання до чорного списку?'
      onClose={this.cancelDeleting}
      onSubmit={this.deleteBooking}
    />),
    deleteBlacklistBooking: (<ConfirmModal
      title='Видалити бронювання з чорного списку?'
      onClose={this.cancelDeleting}
      onSubmit={this.deleteBooking}
    />),
    deleteBlacklistPassenger: (<ConfirmModal
      title='Видалити пасажира з чорного списку?'
      onClose={this.cancelDeleting}
      onSubmit={this.deleteBooking}
    />),
    deleteWaitingPassenger: (<ConfirmModal
      title='Видалити пасажира?'
      onClose={this.cancelDeleting}
      onSubmit={this.deleteBooking}
    />),
    resetSource: (<ConfirmModal
      title='Скинути систему?'
      onClose={this.cancelDeleting}
      onSubmit={this.deleteBooking}
    />),
    deleteUser: (<ConfirmModal
      title='Видалити користувача?'
      onClose={this.cancelDeleting}
      onSubmit={this.deleteBooking}
    />),
    deleteDriver: (<ConfirmModal
      title='Видалити водія?'
      onClose={this.cancelDeleting}
      onSubmit={this.deleteBooking}
    />),
    deleteBus: (<ConfirmModal
      title='Видалити автобус?'
      onClose={this.cancelDeleting}
      onSubmit={this.deleteBooking}
    />),
    printTickets: (<PrintTickets onClose={this.onClose} />),
    printBookingsSheet: (<PrintBookingsSheet onClose={this.onClose} />),
    sourceBookings: (<SourceBookings onClose={this.onClose} />),
    selectRange: (<SelectRange onClose={this.onClose} />),
    printRangeBookings: (<PrintBookingsRangeSheet onClose={this.onClose} />),
    userHistory: (<UserHistory onClose={this.onClose} />),
    passengerInfo: (<PassengerInfoModal onClose={this.onClose} />),
    waitingList: (<WaitingListModal onClose={this.onClose} />),
    blacklistBookingsModal: (<BlacklistBookingsModal onClose={this.onClose} />),
  }

  render() {
    const { classes, modalState, modalType } = this.props

    return (
      <Dialog open={modalState} onClose={this.onClose}>
        <div className={classes.container}>
          {this.types[modalType]}
        </div>
      </Dialog>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/EnhancedModal/EnhancedModal.js